/** Section 6 — the two destructive buttons, each behind a confirm.
 *  "Clear table set-ups" is deliberately absent: that flow does not exist yet. */
import { useState } from 'react';
import { Eraser, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../../lib/api';
import { btn } from './buttons';

export const GoalMaintenanceBlock = ({ cfg, orgId, onReload }) => {
    const [busy, setBusy] = useState(false);

    const clearTables = async () => {
        if (!window.confirm(`Delete all ${cfg.tables_total} table set-ups (email + PIN) for this game? Prizes, wording, branding and settings are not touched — the next tap on a card shows Tonight's game and Set up my table again.`)) return;
        setBusy(true);
        try {
            const res = await api.post('/goal-game/admin/clear-tables', { organization_id: orgId });
            await onReload();
            toast.success(`${res.data.cleared} table set-up(s) cleared`);
        } catch (_e) {
            toast.error('Could not clear the table set-ups');
        } finally { setBusy(false); }
    };

    const clearPlays = async () => {
        if (!window.confirm(`Delete all ${cfg.plays_total} scratch records for this game? Prizes, wording and branding are not touched.`)) return;
        setBusy(true);
        try {
            const res = await api.post('/goal-game/admin/clear-plays', { organization_id: orgId });
            await onReload();
            toast.success(`${res.data.cleared} scratch record(s) cleared`);
        } catch (_e) {
            toast.error('Could not clear the scratches');
        } finally { setBusy(false); }
    };

    return (
        <div className="space-y-3 pt-3">
            <p className="text-sm text-slate-600 dark:text-slate-300">
                Scratch records on file: <strong data-testid="gg-plays-total">{cfg.plays_total}</strong>
                {' · '}Table set-ups tonight: <strong data-testid="gg-tables-total">{cfg.tables_total}</strong>
            </p>
            <div className="flex flex-wrap gap-2">
            <button
                type="button" onClick={clearPlays} disabled={busy}
                data-testid="gg-clear-plays"
                className={btn.warning}
            >
                {busy ? <Loader2 className="animate-spin" size={15} /> : <Eraser size={15} />}
                Clear scratches
            </button>
            <button
                type="button" onClick={clearTables} disabled={busy}
                data-testid="gg-clear-tables"
                className={btn.warning}
            >
                {busy ? <Loader2 className="animate-spin" size={15} /> : <Eraser size={15} />}
                Clear table set-ups
            </button>
            </div>
            <p className="text-xs text-slate-500">
                Clears plays only, so the same phone can play again. Prizes, odds, wording, branding
                and any open round stay exactly as they are. The Goal trigger link already does this
                on every press — and it never clears table set-ups, so you can re-run the demo until
                3:00 a.m. Toronto without setting up again.
            </p>
            <p className="text-xs text-slate-500">
                Clearing table set-ups removes each card's email and hashed PIN. Set-ups expire by
                themselves at 3:00 a.m. Toronto, so this button is only for starting over sooner.
            </p>
        </div>
    );
};

export default GoalMaintenanceBlock;
